module.exports = __webpack_public_path__ + "f580ba0465f36638ba9c572f2059b06a.woff";